import { useMemo } from "react";

import { useDigitalReceptionMetadata } from "./useQueryBoard";
import { useLanguage } from "../../bit/language";

const ACCESS_EVENT_TYPE: Record<string, AccessEventType> = {
  package: "Package",
  food: "Food",
};

export const useDeliverySuccessMessage = (action: "package" | "food") => {
  const metadata = useDigitalReceptionMetadata();

  const [language] = useLanguage();

  return useMemo(() => {
    const delivery = metadata?.message?.delivery;

    const texts = delivery?.[ACCESS_EVENT_TYPE[action]];

    return {
      title:
        typeof texts?.title?.[language] === "string"
          ? texts.title[language]
          : undefined,
      message:
        typeof texts?.message?.[language] === "string"
          ? texts.message[language]
          : undefined,
      durationMs: delivery?.durationMs,
    };
  }, [metadata, action, language]);
};
